import { BillPaymentReportApi } from "../api"

export class BillPaymentReport {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
    this.paymentTimeStamp = props.paymentTimeStamp ? props.paymentTimeStamp.iso : null
  }

  static async getBillPaymentReportBetweenDateByMarket(marketId, startDate, endDate) {
    const { data } = await BillPaymentReportApi.getBillPaymentReportBetweenDateByMarket(
      marketId,
      startDate,
      endDate
    );
    return data.result.map(item => new BillPaymentReport(item));
  }
  
  static async getBillPaymentReportBetweenDateByProject(formData) {
    const { data } = await BillPaymentReportApi.getBillPaymentReportBetweenDateByProject(formData);
    return data.result.map(item => new BillPaymentReport(item));
  }
}